module.exports = __webpack_public_path__ + "img/type2.63151ed2.png";